document.addEventListener('DOMContentLoaded', () => {
  const els = document.querySelectorAll("[data-services-reveal]");
  if (els.length === 0) return;
  
  const obs = new IntersectionObserver((es, o) => {
    es.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add("dz-revealed");
        o.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });
  
  els.forEach(e => obs.observe(e));
});
